var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{staticClass:"text-right"},[_c('small',[_vm._v(" "+_vm._s(Math.ceil((_vm.text.length + _vm.optOutLength) / 160))+" / "+_vm._s(_vm.textCount)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }